import styled from "@emotion/styled";
import { FolderItem24Icon } from "@kaltura/ds-react-icons";

export const StyledFolderIcon = styled(FolderItem24Icon)(({ theme }) => ({
    width: theme.typography.pxToRem(18),
    height: theme.typography.pxToRem(18),
    color: "#B8D7FF",
}));

export const StyledForm = styled("form")({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
});
